import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";

interface TDEECardProps {
  tdee?: number;
  activeEnergy?: number;
  restingEnergy?: number;
  source?: string;
  showEmptyState?: boolean;
}

export const TDEECard: React.FC<TDEECardProps> = ({
  tdee,
  activeEnergy,
  restingEnergy,
  source,
  showEmptyState = false,
}) => {
  return (
    <Card
      sx={{
        height: "100%",
        background: "#f8fafb",
        border: "1px solid #eaecf0",
        borderRadius: 0.75,
        boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
      }}
    >
      <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1, "&:last-child": { paddingBottom: 2 } }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, fontSize: 12, lineHeight: "16px" }}>
          Total Daily Energy Expenditure (TDEE)
        </Typography>

        {showEmptyState ? (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 4 }}>
            <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center" }}>
              No energy expenditure data available for today
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography variant="h3" sx={{ fontSize: 20, lineHeight: "28px" }}>
              {tdee != null ? `${Math.round(tdee).toLocaleString()} kcal` : "—"}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: "20px" }}>
              Active: {activeEnergy != null ? `${Math.round(activeEnergy).toLocaleString()} kcal` : "—"} | Resting: {restingEnergy != null ? `${Math.round(restingEnergy).toLocaleString()} kcal` : "—"} | Source: {source || "—"}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
